import { Component, Input } from "@angular/core";

@Component({
  selector: "snt-warning",
  template: "",
  standalone: false
})
export class WarningComponent {
  @Input()
  icon: string | undefined;

  @Input()
  message: string | undefined;

  @Input()
  link: string | undefined;

  @Input()
  linkText: string | undefined;
}
